import { render, staticRenderFns } from "./DpartDetailsDialog.vue?vue&type=template&id=19fcd702&scoped=true&"
import script from "./DpartDetailsDialog.vue?vue&type=script&lang=js&"
export * from "./DpartDetailsDialog.vue?vue&type=script&lang=js&"
import style0 from "./DpartDetailsDialog.vue?vue&type=style&index=0&id=19fcd702&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19fcd702",
  null
  
)

export default component.exports